module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "SUPERADMIN"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.SuperAdministrator), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "ADMIN"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Administrator), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "PARTNER"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Partner), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "REFERRER"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign&Client:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Referrer), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "CLIENT"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Client), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "CLIENT_AUTOMATION"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.ClientAutomation), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])])], 1), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.setDefaultPermissions
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Установить значения по умолчанию")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-industry"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6deb9466"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/settings/Permissions.vue
// module id = 565
// module chunks = 42